import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/Index.vue';
import Logs from '../views/Logs.vue';
import Home from '../views/Home.vue';
import Farms from '../views/Farms.vue';
import Users from '../views/Users.vue';
import Inventory from '../views/Inventory.vue';
import Settings from '../views/Settings.vue';
import Repairs from '../views/Repairs.vue';
import Repair from '../views/Repair.vue';
import SupportCalls from '../views/SupportCalls.vue';

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: () => import('../views/Forgot.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    children: [
      {
        path: '',
        redirect: 'home'
      },
      {
        path: 'home',
        name: 'Home',
        component: Home
      },
      {
        path: 'logs',
        name: 'Logs',
        component: Logs
      },
      {
        path: 'farms',
        name: 'Farms',
        component: Farms
      },
      {
        path: 'users',
        name: 'Users',
        component: Users
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      },
      {
        // Ahora acepta un tercer parámetro opcional: extraParam
        path: 'repair/:ticketId?/:sn?/:extraParam?',
        name: 'Repair',
        component: Repair,
        props: true
      },
      {
        path: 'inventory',
        name: 'Inventory',
        component: Inventory
      },
      {
        path: 'repairs',
        name: 'Repairs',
        component: Repairs,
        props: true
      },
      {
        path: 'support-calls',
        name: 'SupportCalls',
        component: SupportCalls
      },
    ]
  },
  {
    path: '/printRemoteCalls/:jobName/:startDate/:endDate',
    name: 'PrintRemoteCalls',
    component: () => import('../views/printRemoteCalls.vue'),
    props: true
  },
  {
    path: '/print-support-call/:id',
    name: 'PrintRemoteCall',
    component: () => import('../views/printRemoteCall.vue'),
    props: true
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;